import { CUSTOMER_LOYALTY_EMAIL } from 'Constants/env';
import { INTEREST_EMAIL_SUBJECT } from 'Constants/interestEmail';
import { usePersonStore } from 'Modules/person/index.store';
import { capitalizeFirstLetter } from 'Utils/capitalizeFirstLetter';

/**
 * Returns the plain-text body for the interest email.
 *
 * Includes the user's ID, current package, organization name,
 * organization ID, and full name when available.
 * Missing values are rendered as empty strings.
 */
const buildInterestEmailBody = (): string => {
  const { id, package: accountPackage, account, firstName, lastName } =
    usePersonStore.getState();

  const userId = id?.toString() ?? '';
  const packageName = capitalizeFirstLetter(accountPackage);
  const accountName = account?.name ?? '';
  const accountId = account?.id?.toString() ?? '';
  const userName = `${firstName ?? ''} ${lastName ?? ''}`.trim();

  return `Hello,\n\nI'm interested in getting access to Video Calls on Communicator and would like to know more about upgrading to the Pro package.\n\nPlease find my details below.\n\n \n\nUser ID: ${userId}\n\nCurrent Package: ${packageName}\n\nOrganization: ${accountName}\n\nOrganization ID: ${accountId}\n\n \n\nThank you,\n\n\n${userName}`;
};

/**
 * Returns a pre-filled 'mailto:' link for the interest email.
 *
 * The subject and body are URL-encoded before being added to the link.
 */
export const buildInterestMailtoLink = (): string => {
  const subject = encodeURIComponent(INTEREST_EMAIL_SUBJECT);
  const body = encodeURIComponent(buildInterestEmailBody());

  return `mailto:${CUSTOMER_LOYALTY_EMAIL}?subject=${subject}&body=${body}`;
};